// extracted by mini-css-extract-plugin
export default {"collapseHeader":"eonkBYR4v7MsRvMbh1Ca__collapseHeader___","small":"yl0NmjhjulKvVIrIGR2a__small___"};